(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvResultController', EnvResultController);

    EnvResultController.$inject = ['machine', '$scope', 'EnvResultSearch', 'EnvResult', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'filterRes', 'EnvResultFile', 'PopupService'];

    function EnvResultController(machine, $scope, EnvResultSearch, EnvResult, $q, DTColumnBuilder,
                                 DTOptionsBuilder, GUIUtils, $filter, $compile, filterRes, EnvResultFile, PopupService) {
        var vm = this;
        vm.title = 'Latest Site Results';
        vm.entityClassHumanized = 'Latest Environmental Results';
        vm.entityStateName = 'env-result';

        vm.machine = machine;
        vm.envResults = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.filterRes = filterRes;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.isFilter) {
                defer.resolve(vm.envResults);
                vm.isFilter = false;
            } else if (!vm.searchQuery || vm.searchQuery == '') {
                EnvResult.by_machine({id: vm.machine.id}, function (result) {
                    vm.envResults = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.envResults, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('machine').withTitle('Machine'),
            DTColumnBuilder.newColumn('accessionNumber').withTitle('BarCode'),
            DTColumnBuilder.newColumn(null).withTitle('Order ID').renderWith(function (data, type, full) {
                return data.order ? data.order.id : "";
            }),
            DTColumnBuilder.newColumn('status').withTitle('Status'),
            DTColumnBuilder.newColumn(null).withTitle('Collection Date').renderWith(function (data, type, full) {
                return moment(data.collectionDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Result Date').renderWith(function (data, type, full) {
                return moment(data.createdDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('').withTitle('').withOption('width', '155px').notSortable()
                .renderWith(abnormalHtml),
            DTColumnBuilder.newColumn('').withTitle('').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function abnormalHtml(data, type, full, meta) {
            if (full.abnormal) {
                return GUIUtils.getStatusTemplate('ABNORMAL', 'danger');
            } else {
                return GUIUtils.getStatusTemplate('NORMAL', 'success');
            }
        }

        function actionsHtml(data, type, full, meta) {
            return '<div>' +
                '<div class="btn-group" uib-dropdown>' +
                '<button type="button" class="btn btn-default" ng-click="vm.getPDF(' + full.id + ')">View PDF</button>' +
                '<button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle ng-disabled="disabled" data-toggle="dropdown" aria-expanded="false">' +
                '<span class="caret"></span>' +
                '<span class="sr-only">Toggle Dropdown</span>' +
                '</button>' +
                '<ul class="dropdown-menu" uib-dropdown-menu role="menu">' +
                '<li><a ng-click="vm.details(' + full.id + ')">Details</a></li>' +
                '</ul>' +
                '</div></div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        vm.getPDF = function (id) {
            EnvResultFile.getByEnvResult(id);
        }

        vm.popoverFilterEnable = popoverFilterEnable;
        vm.showFilter = false;

        function popoverFilterEnable() {
            vm.showFilter = !vm.showFilter;
        }

        vm.isFilter = false;
        vm.filter = filter;

        function filter() {
            if (!vm.filterRes.name && !vm.filterRes.start && !vm.filterRes.end && !vm.filterRes.status) {
                return;
            }

            vm.isFilter = true;

            var must = [];
            must.push({term: {"order.machine.id": machine.id}});
            must.push({term: {"delStatus": false}});

            if (vm.filterRes.status != null && vm.filterRes.status.length > 0) {
                must.push({match: {status: {query: vm.filterRes.status}}});
            }

            if (vm.filterRes.start) {
                must.push({range: {createdDate: {gte: vm.filterRes.start}}});
            }

            if (vm.filterRes.end) {
                var end = new Date(vm.filterRes.end);
                end.setHours(23, 59, 59);
                must.push({range: {createdDate: {lte: end}}});
            }

            EnvResultSearch.query(
                {
                    query: {
                        bool: {
                            must: must
                        }
                    }
                }, function (result) {
                    vm.envResults = result;
                    vm.dtInstance.reloadData();
                });
        }

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.end = false;

        vm.openCalendar = openCalendar;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.clear = clear;

        function clear() {
            vm.filterRes = {
                name: null,
                start: null,
                end: null,
                status: null
            };

            vm.isFilter = false;
            vm.dtInstance.reloadData();
        }

        vm.details = details;

        function details(id) {
            PopupService.showEnvResultDetPopup(id);
        }
    }
})();
